import { render, staticRenderFns } from "./bigScreenStudy.vue?vue&type=template&id=31b74c9e&scoped=true"
import script from "./bigScreenStudy.vue?vue&type=script&lang=js"
export * from "./bigScreenStudy.vue?vue&type=script&lang=js"
import style0 from "./bigScreenStudy.vue?vue&type=style&index=0&id=31b74c9e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b74c9e",
  null
  
)

export default component.exports